<template>
  <div class="samplingPrinciple">
    <van-nav-bar title="采样一般原则" v-if="isWx==1" left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
    <van-nav-bar title="采样一般原则" v-else fixed></van-nav-bar>
    <div class="navheight"></div>
    <div v-for="(item,index) in contentList" :key="index" class="content">
        <span>{{item.textItem}}</span>
    </div>
    <Top :btnFlag="btnFlag"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Top from '@/components/top.vue'
export default {
  name: 'samplingprinciple',
  components: {
    Top
  },
  data(){
    return{
      btnFlag:false,
      contentList:[
        {
          textItem:'(1)先排除后取样：可能的病因、非传染病因素、背景信息；',
        },
        {
          textItem:'(2)尽“早”采样：关注疫病的病程，采样时机合理； ',
        },
        {
          textItem:'(3)尽量保持采样环境的洁净；',
        },
        {
          textItem:'(4)采样工具或盛样器具应当洁净、干燥，必要时做灭菌处理；',
        },
        {
          textItem:'(5)应遵循由表及里、由胸腔到腹腔、由实质脏器到消化道的原则；',
        },
        {
          textItem:'(6)采样种类要齐全：“全”与“准”；',
        },
        {
          textItem:'(7)采取有代表性的病料；',
        },
        {
          textItem:'(8)尽量减少对动物的应激；',
        },
        {
          textItem:'(9)采样数量满足生物统计学要求：一般需要满足95%置信度的要求；',
        },
        {
          textItem:'(10)样品背景信息要完整：日龄、免疫程序、用药情况；拍照；',
        },
        {
          textItem:'(11)生物安全：采样时做好生物安全防控；后续处理得当，避免因采样造成疫病扩散。',
        },
      ],
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      isWx:1,
    }
  },
  
  created(){
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf('micromessenger') == -1) {
      this.isWx = 1
    }else{
      this.isWx = 2
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    }
  }
}
</script>

<style lang="scss">
.samplingPrinciple{
    .van-nav-bar .van-icon{
        color: #999999;
    }
    .content{
        padding: 4px 14px 10px;
        text-align: left !important;
        font-size:14px;
        font-family:PingFangSC-Regular;
        line-height:1.5;
        color:rgba(32,32,32,1);
        opacity:1;
    }
}
.van-button--normal {
  width: 40%;
  margin: 10px;
}
.navheight {
  height: 46px;
}
</style>
